const _ = require('lodash');

const durationReg = /^P(?:(?<weeks>\d+(?:\.\d+)?W)|(?:(?<years>\d+(?:\.\d+)?Y)?(?<months>\d+(?:\.\d+)?M)?(?<days>\d+(?:\.\d+)?D)?(?:T(?<hours>\d+(?:\.\d+)?H)?(?<minutes>\d+(?:\.\d+)?M)?(?<seconds>\d+(?:\.\d+)?S)?)?))$/;
const durationKeys = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds', 'nanoseconds'];

function tryParseObjectString(value) {
	if (!_.isString(value)) {
		return value;
	}

	const cleaned = value
		.trim()
		.replace(/([{,]\s*)([a-zA-Z_]\w*)\s*:/g, '$1"$2":');

	try {
		return JSON.parse(cleaned);
	} catch {
		return value;
	}
}

function toNumber(value) {
	if (_.isString(value)) {
		const trimmed = value.trim();
		if (!trimmed) {
			return 0;
		}

		const numericPortion = /[a-zA-Z]$/.test(trimmed) ? trimmed.slice(0, -1) : trimmed;
		const parsed = Number(numericPortion);
		return _.isFinite(parsed) ? parsed : 0;
	}

	return _.isFinite(value) ? Number(value) : 0;
}

function splitSeconds(value) {
	let seconds = Math.trunc(value);
	let nanoseconds = Math.round((value - seconds) * 1e9);

	if (nanoseconds >= 1e9) {
		seconds += 1;
		nanoseconds -= 1e9;
	}

	return {
		seconds,
		nanoseconds
	};
}

function isDurationValue(value) {
	value = tryParseObjectString(value);

	if (_.isString(value)) {
		return durationReg.test(value);
	}

	if (_.isPlainObject(value)) {
		if (!_.some(durationKeys, key => _.has(value, key))) {
			return false;
		}

		return _.every(value, (item, key) => durationKeys.includes(key) && _.isNumber(item));
	}

	return false;
}

function parseDurationObject(value, driver = null) {
	value = tryParseObjectString(value);

	if (!_.isString(value) && !_.isPlainObject(value)) {
		throw new Error('Invalid duration input');
	}

	let groups;

	if (_.isString(value)) {
		const match = value.match(durationReg);
		if (!match) {
			throw new Error('Invalid duration');
		}

		groups = match.groups || {};
	} else {
		groups = value;
	}

	const years = toNumber(groups.years);
	const months = toNumber(groups.months);
	const weeks = toNumber(groups.weeks);
	const days = toNumber(groups.days);
	const hours = toNumber(groups.hours);
	const minutes = toNumber(groups.minutes);
	const seconds = toNumber(groups.seconds);
	const nanoseconds = toNumber(groups.nanoseconds);

	if (driver === 'falkordb') {
		const normalizedSeconds = splitSeconds(seconds + (nanoseconds / 1e9));

		return {
			years: years || 0,
			months: months || 0,
			weeks: weeks || 0,
			days: days || 0,
			hours: hours || 0,
			minutes: minutes || 0,
			seconds: normalizedSeconds.seconds || 0,
			nanoseconds: normalizedSeconds.nanoseconds || 0
		};
	}

	const totalMonths = (years * 12) + months;
	const totalDays = (weeks * 7) + days;
	const totalSeconds = (hours * 3600) + (minutes * 60) + seconds + (nanoseconds / 1e9);
	const normalizedSeconds = splitSeconds(totalSeconds);

	return {
		months: totalMonths || 0,
		days: totalDays || 0,
		seconds: normalizedSeconds.seconds || 0,
		nanoseconds: normalizedSeconds.nanoseconds || 0
	};
}

module.exports = {
	isDurationValue,
	parseDurationObject
};
